import { TextLabels } from "types/textLabels";

export const flusLabels: TextLabels = {
  wizardStep2_linePricingDownloadFile_endpoint: "/line-pricing/download",
  wizardStep2_linePricingDownloadFile: "Line-Pricing-Grouping",
  wizardStep2_linePricing: "Line Pricing",
  wizardStep2_linePricingDownload: "Download Line Price Groupings",
  wizardStep2_linePricingOptions: "Line price BU/ Sizes",
  wizardStep2_linePricingTooltip:
    "When off, each BU size will be priced independently. When on, custom line pricing will be followed while optimizing.",
  wizardStep2_minVolume: "Min Volume (lbs)",
  wizardStep2_maxVolume: "Max Volume (lbs)",
  wizardStep2_minNetRevenue: "Min Net Rev per Pound ($/lb)",
  wizardStep2_minNetRevTooltip:
    "Minimum allowable net revenue per lb in the current scenario compared to reference (e.g., 98% means current scenario net revenue per lb must be at least 98% of reference scenario net revenue per lb)",
  wizardStep2_maxNetRevenue: "Max Net Rev per Pound ($/lb)",
  wizardStep2_maxNetRevTooltip:
    "Maximum allowable net revenue per lb in the current scenario compared to reference (e.g., 200% means current scenario net revenue per lb must be at most 200% of reference scenario net revenue per lb)",
  wizardStep2_minGrossMarginTooltip:
    "Minimum allowable gross profit in the current scenario compared to reference (e.g., 98% means current scenario gross profit must be at least 98% of reference scenario gross profit)",
  wizardStep2_maxGrossMarginTooltip:
    "Maximum allowable gross profit in the current scenario compared to reference (e.g., 200% means current scenario gross profit must be at most 200% of reference scenario gross profit)",
  wizardStep2_minVolumeTooltip:
    "Minimum allowable volume in the current scenario compared to reference (e.g., 98% means current scenario volume must be at least 98% of reference scenario volume)",
  wizardStep2_maxVolumeTooltip:
    "Maximum allowable volume in the current scenario compared to reference (e.g., 200% means current scenario volume must be at most 200% of reference scenario volume)",
  wizardStep2_minMarketShareTooltip:
    "Minimum allowable market share in the current scenario (e.g., 70% means current scenario market share must be at least 70%)",
  wizardStep2_maxMarketShareTooltip:
    "Maximum allowable market share in the current scenario (e.g., 200% means current scenario market share must be at most 200%)",
  wizardStep2_minNetSalesTooltip:
    "Minimum allowable net sales in the current scenario compared to reference (e.g., 98% means current scenario sales must be at least 98% of reference scenario sales)",
  wizardStep2_maxNetSalesTooltip:
    "Maximum allowable net sales in the current scenario compared to reference (e.g., 200% means current scenario sales must be at most 200% of reference scenario sales)",
  wizardStep3_HeadCells_subCategory: "SUBCATEGORY",
  wizardStep3_HeadCells_bu: "BU",
  wizardStep3_HeadCells_buSize: "BU SIZE",
  wizardStep3_HeadCells_actualPackSize: "PACK SIZE (OZ)",
  wizardStep3_HeadCells_weightOut: "WEIGHT OUT (OZ)",
  wizardStep5_weightOut: "Weight Outs",
  wizardStep5_weightUnit: "oz",
  scenarioList_grossProfit_line1: "Gross",
  scenarioList_grossProfit_line2: "Profit ($ B)",
  scenarioList_netRevenue_line1: "Net",
  scenarioList_netRevenue_line2: "Revenue ($ B)",
  scenarioList_rsv_line1: "RSV ($ B)",
  scenarioList_rsv_line2: "",
  scenarioList_units_line1: "Units (MM)",
  scenarioList_units_line2: "",
  scenarioList_volume_line1: "Volume",
  scenarioList_volume_line2: "(MM LBS)",
  scenarioList_volumeShare_line1: "Volume",
  scenarioList_volumeShare_line2: "Share",
  scenarioList_marketShare_line1: "Market",
  scenarioList_marketShare_line2: "Share",
  wizardStep4_buSize: "BU Size",
  wizardStep4_linePriceGroup: "Line Price Group",
  wizardStep4_linePrice: "line price",
  wizardStep4_symbol: "%",
  elasticityGraph_brandSize: "BRAND/SIZE",
  dashboard_filters_product: "BU/SIZE",
};

export const pmfLabels: TextLabels = {
  wizardStep2_linePricingDownloadFile_endpoint: "/tier-pricing/download",
  wizardStep2_linePricingDownloadFile: "Price-Tier-Rules",
  wizardStep2_linePricing: "Price Tiers",
  wizardStep2_linePricingDownload: "Download Price Tier Rules",
  wizardStep2_linePricingOptions: "Enable Price Tiers",
  wizardStep2_linePricingTooltip:
    "When off, each brand pack will be priced independently. When on, price tier rules will be followed while optimizing.",
  wizardStep2_minVolume: "Min Volume (kg)",
  wizardStep2_maxVolume: "Max Volume (kg)",
  wizardStep2_minNetRevenue: "Min Net Rev per kg ($/kg)",
  wizardStep2_minNetRevTooltip:
    "Minimum allowable net revenue per kg in the current scenario compared to reference (e.g., 98% means current scenario net revenue per kg must be at least 98% of reference scenario net revenue per kg)",
  wizardStep2_maxNetRevenue: "Max Net Rev per kg ($/kg)",
  wizardStep2_maxNetRevTooltip:
    "Maximum allowable net revenue per kg in the current scenario compared to reference (e.g., 200% means current scenario net revenue per kg must be at most 200% of reference scenario net revenue per kg)",
  wizardStep2_minGrossMarginTooltip:
    "Minimum allowable gross profit in the current scenario compared to reference (e.g., 98% means current scenario gross profit must be at least 98% of reference scenario gross profit)",
  wizardStep2_maxGrossMarginTooltip:
    "Maximum allowable gross profit in the current scenario compared to reference (e.g., 200% means current scenario gross profit must be at most 200% of reference scenario gross profit)",
  wizardStep2_minVolumeTooltip:
    "Minimum allowable volume in the current scenario compared to reference (e.g., 98% means current scenario volume must be at least 98% of reference scenario volume)",
  wizardStep2_maxVolumeTooltip:
    "Maximum allowable volume in the current scenario compared to reference (e.g., 200% means current scenario volume must be at most 200% of reference scenario volume)",
  wizardStep2_minMarketShareTooltip:
    "Minimum allowable market share in the current scenario (e.g., 70% means current scenario market share must be at least 70%)",
  wizardStep2_maxMarketShareTooltip:
    "Maximum allowable market share in the current scenario (e.g., 200% means current scenario market share must be at most 200% of reference scenario market share)",
  wizardStep2_minNetSalesTooltip:
    "Minimum allowable net sales in the current scenario compared to reference (e.g., 98% means current scenario sales must be at least 98% of reference scenario sales)",
  wizardStep2_maxNetSalesTooltip:
    "Maximum allowable net sales in the current scenario compared to reference (e.g., 200% means current scenario sales must be at most 200% of reference scenario sales)",
  wizardStep3_HeadCells_subCategory: "SUBCATEGORY",
  wizardStep3_HeadCells_bu: "SUB BRAND",
  wizardStep3_HeadCells_buSize: "BRAND PACKS",
  wizardStep3_HeadCells_actualPackSize: "PACK SIZE (G)",
  wizardStep3_HeadCells_weightOut: "WEIGHT CHANGE (G)",
  wizardStep5_weightOut: "Weight Change",
  wizardStep5_weightUnit: "g",
  scenarioList_grossProfit_line1: "Gross",
  scenarioList_grossProfit_line2: "Profit ($ B)",
  scenarioList_netRevenue_line1: "Net",
  scenarioList_netRevenue_line2: "Revenue ($ B)",
  scenarioList_rsv_line1: "RSV ($ B)",
  scenarioList_rsv_line2: "",
  scenarioList_units_line1: "Units (MM)",
  scenarioList_units_line2: "",
  scenarioList_volume_line1: "Volume",
  scenarioList_volume_line2: "(MM KG)",
  scenarioList_volumeShare_line1: "Volume",
  scenarioList_volumeShare_line2: "Share",
  scenarioList_marketShare_line1: "Market",
  scenarioList_marketShare_line2: "Share",
  wizardStep4_buSize: "Brand Packs",
  wizardStep4_linePriceGroup: "Price Tiers",
  wizardStep4_linePrice: "price tiers",
  wizardStep4_symbol: "$",
  elasticityGraph_brandSize: "BRAND/SIZE",
  dashboard_filters_product: "BU/SIZE",
};

export const ukLabels: TextLabels = {
  wizardStep2_linePricingDownloadFile_endpoint: "/line-pricing/download",
  wizardStep2_linePricingDownloadFile: "Line-Pricing-Grouping",
  wizardStep2_linePricing: "Line Pricing",
  wizardStep2_linePricingDownload: "Download Line Price Groupings",
  wizardStep2_linePricingOptions: "Line price BU/ Sizes",
  wizardStep2_linePricingTooltip:
    "When off, each BU size will be priced independently. When on, custom line pricing will be followed while optimizing.",
  wizardStep2_minVolume: "Min Volume (lbs)",
  wizardStep2_maxVolume: "Max Volume (lbs)",
  wizardStep2_minNetRevenue: "Min Net Rev per Pound ($/lb)",
  wizardStep2_minNetRevTooltip:
    "Minimum allowable net revenue per lb in the current scenario compared to reference (e.g., 98% means current scenario net revenue per lb must be at least 98% of reference scenario net revenue per lb)",
  wizardStep2_maxNetRevenue: "Max Net Rev per Pound ($/lb)",
  wizardStep2_maxNetRevTooltip:
    "Maximum allowable net revenue per lb in the current scenario compared to reference (e.g., 200% means current scenario net revenue per lb must be at most 200% of reference scenario net revenue per lb)",
  wizardStep2_minGrossMarginTooltip:
    "Minimum allowable gross profit in the current scenario compared to reference (e.g., 98% means current scenario gross profit must be at least 98% of reference scenario gross profit)",
  wizardStep2_maxGrossMarginTooltip:
    "Maximum allowable gross profit in the current scenario compared to reference (e.g., 200% means current scenario gross profit must be at most 200% of reference scenario gross profit)",
  wizardStep2_minVolumeTooltip:
    "Minimum allowable volume in the current scenario compared to reference (e.g., 98% means current scenario volume must be at least 98% of reference scenario volume)",
  wizardStep2_maxVolumeTooltip:
    "Maximum allowable volume in the current scenario compared to reference (e.g., 200% means current scenario volume must be at most 200% of reference scenario volume)",
  wizardStep2_minMarketShareTooltip:
    "Minimum allowable market share in the current scenario (e.g., 70% means current scenario market share must be at least 70%)",
  wizardStep2_maxMarketShareTooltip:
    "Maximum allowable market share in the current scenario (e.g., 200% means current scenario market share must be at most 200% of reference scenario market share)",
  wizardStep2_minNetSalesTooltip:
    "Minimum allowable net sales in the current scenario compared to reference (e.g., 98% means current scenario sales must be at least 98% of reference scenario sales)",
  wizardStep2_maxNetSalesTooltip:
    "Maximum allowable net sales in the current scenario compared to reference (e.g., 200% means current scenario sales must be at most 200% of reference scenario sales)",
  wizardStep3_HeadCells_subCategory: "SUBCATEGORY",
  wizardStep3_HeadCells_bu: "BU",
  wizardStep3_HeadCells_buSize: "BU SIZE",
  wizardStep3_HeadCells_actualPackSize: "PACK SIZE (OZ)",
  wizardStep3_HeadCells_weightOut: "WEIGHT OUT (OZ)",
  wizardStep5_weightOut: "Weight Outs",
  wizardStep5_weightUnit: "oz",
  scenarioList_grossProfit_line1: "Gross",
  scenarioList_grossProfit_line2: "Profit ($ B)",
  scenarioList_netRevenue_line1: "Net",
  scenarioList_netRevenue_line2: "Revenue ($ B)",
  scenarioList_rsv_line1: "RSV ($ B)",
  scenarioList_rsv_line2: "",
  scenarioList_units_line1: "Units (MM)",
  scenarioList_units_line2: "",
  scenarioList_volume_line1: "Volume",
  scenarioList_volume_line2: "(MM LBS)",
  scenarioList_volumeShare_line1: "Volume",
  scenarioList_volumeShare_line2: "Share",
  scenarioList_marketShare_line1: "Market",
  scenarioList_marketShare_line2: "Share",
  wizardStep4_buSize: "BU Size",
  wizardStep4_linePriceGroup: "Line Price Group",
  wizardStep4_linePrice: "line price",
  wizardStep4_symbol: "%",
  elasticityGraph_brandSize: "PPG/SUBCATEGORY",
  dashboard_filters_product: "PPG",
};
